export default __webpack_public_path__ + "static/media/Graphics_letterpad-03-min.e4515c10.jpg";